module.exports = {
    title: "Genre",
    crud: {
        create: "Create Genre",
        edit: "Edit Genre",
    },
    table: {
        name: "Name",
    },
    form: {
        name: "Name",
    },
    validation: {
        required: {
            name: 'Name is required',
        },
        minLength: {
            name: 'Name must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
